// extracted by mini-css-extract-plugin
export default {"privacy":"Av9UD1AnRT1VJk61_jsY"};